import React from 'react';
import { MaterialUiCore } from '@gscope-mfe/common-libs';
import { useTranslation } from 'react-i18next';
import classes from './LogoutModal.module.css';
const { Modal, Box, Button } = MaterialUiCore;
const LogoutModal = ({ modalShow, logoutHandler, setModalShow }) => {
    const { t } = useTranslation('commonLang');
    return (
        <Modal
            open={modalShow}
            onClose={() => setModalShow(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            style={{ top: '40%' }}
            data-testid="logout-modal"
        >
            <Box
                className={classes.modalLogout}
                sx={{ background: 'white', width: '100%', padding: '10px', borderRadius: '8px' }}
            >
                <h4 id="child-modal-title" style={{ fontWeight: 'bold' }}>
                    {t('confirmLogout')}
                </h4>
                <hr style={{ width: '100%', height: '1px' }}></hr>
                <div id="child-modal-description" className={classes.description}>
                    <p id="child-modal-description">{t('logoutPrompt')}</p>
                </div>
                <hr style={{ width: '100%', height: '1px' }}></hr>
                <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <Button
                        data-testid="my-logout-cancel"
                        className={classes.logoutCancel}
                        onClick={(e) => {
                            e.stopPropagation();
                            setModalShow(false);
                        }}
                    >
                        {t('cancel')}
                    </Button>
                    <Button
                        data-testid="my-logout-button"
                        variant="contained"
                        className={classes.logoutButton}
                        onClick={logoutHandler}
                    >
                        {t('yes')}
                    </Button>
                </div>
            </Box>
        </Modal>
    );
};
export default LogoutModal;
